export class RoutesDefaults {
  public static readonly ONLINE_RESOURCES = 'online-resources';
  public static readonly OWN_DATASET = 'own-dataset';
  public static readonly UPLOADED_PROJECT = 'uploaded-project';
  public static readonly GWS_GENERATOR = 'gws-generator';
  public static readonly MODEL_MODULE = 'model';
}
